import * as Sentry from '@sentry/nextjs';
import { sharedSentryOptions } from '../sentry.shared';

Sentry.init({
  ...sharedSentryOptions,
  // No session replay: it would record screens containing health data
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
